import React, { memo } from 'react';

export const DropCrossedOut: React.FC = memo(() => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" fill="white" />
    <path
      d="M24 18.3996C24 11.1996 16 5.59961 16 5.59961C16 5.59961 8 11.1996 8 18.3996C8 20.5213 8.84285 22.5562 10.3431 24.0565C11.8434 25.5568 13.8783 26.3996 16 26.3996C18.1217 26.3996 20.1566 25.5568 21.6569 24.0565C23.1571 22.5562 24 20.5213 24 18.3996Z"
      stroke="#919395"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="4 4"
    />
    <line x1="7.89095" y1="7.78658" x2="24.8556" y2="26.8328" stroke="#919395" />
  </svg>
));
